import axios from "axios";
import { store } from "../../store";

type CreateNewsProps = {
  languageId: number;
  constantId: number;
};

export async function createNewsAction({
  languageId,
  constantId,
}: CreateNewsProps) {
  const token =
    sessionStorage.getItem("token") ?? localStorage.getItem("token");
  const { title, description } = store.getState().news;
  const dataToSend = {
    languageId,
    constantId,
    title,
    description,
  };

  return await axios
    .post(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/news/create`,
      dataToSend,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data);
}
